import { createInternalTransferAsync } from '../../../../../API/order/escrow/EscrowAPI';
import { createAsyncSlice } from 'store/createAsyncSlice';

export const { slice: createInternalTransferSlice, asyncAction: createInternalTransferAction } = createAsyncSlice(
  'createInternalTransferSlice',
  createInternalTransferAsync
);
